import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk';
import rootReducer  from './reducers.js'
import cloneDeep from 'lodash/cloneDeep'

import { NOTIFY, REMOVE_NOTIFICATION, RESET } from './notifications/actionTypes'




const logger = store => next => action => {
  if (action && action.type) {
    console.log('Redux - Dispatch ' + action.type, action)
  } else {
    console.log('Redux - Dispatch failed invalid action?', action)
  }

  /*
   There seems to be a memory leak in the clearing up of the message notifications causing action to be null
   in the notifications actions
   we will just ignore these at the risk of a memory error and any other invalid actions.
  */
   if ( typeof action ==='undefined' || action === null || (typeof action==='object' && action.type === undefined )) {
    console.log('Redux - Cancelable invalid action! ', action)
    return false;
  }
  
  let result = next(action)
  const savedState = cloneDeep(store.getState())
  console.log('Redux - Next State', savedState )
  return result
}
/*
const crashReporter = store => next => action => {
  try {
    return next(action)
  } catch (err) {
    console.error('Caught an exception!', err)
    throw err
  }
}
*/
// Redux with redux-devtools in chrome/firefox
//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
//const appStore = createStore(rootReducer, /* preloadedState, */ composeEnhancers(applyMiddleware(  crashReporter, thunk, logger,  )));

// TODO Configure Redux for Production ?

if ( typeof createStore === 'undefined') throw 'createStore' 
if ( typeof rootReducer === 'undefined') throw 'rootReducer' 
if ( typeof applyMiddleware === 'undefined') throw 'applyMiddleware' 
if ( typeof thunk === 'undefined') throw 'thunk' 
if ( typeof logger === 'undefined') throw 'logger' 


const appStore = createStore(rootReducer, applyMiddleware(  thunk, logger ));

export function getStore() { return appStore };
